module.exports = __webpack_public_path__ + "static/hero-mobile-d25c0ca9190cccf4f145cdb6852d60eb.gif";